// extracted by mini-css-extract-plugin
export var description = "Parameter-module--description--1bc24";
export var indent = "Parameter-module--indent--b1f6e";
export var item = "Parameter-module--item--2a8cd";
export var padded = "Parameter-module--padded--996aa";